(function () {
  var wrapper = document.querySelector('predictive-search');
  if (!wrapper) return;

  var input = wrapper.querySelector('input[name="q"]');
  var resultsEl = wrapper.querySelector('.predictive-search__results');
  var debounceTimer;

  function render(data) {
    var products = (data.resources && data.resources.results && data.resources.results.products) || [];
    var queries = (data.resources && data.resources.results && data.resources.results.queries) || [];

    if (!products.length && !queries.length) {
      resultsEl.innerHTML = '<p class="predictive-search__empty">' + (window.themeStrings && window.themeStrings.noSuggestions || 'Öneri bulunamadı') + '</p>';
      resultsEl.hidden = false;
      return;
    }

    var html = '';
    if (queries.length) {
      html += '<ul class="predictive-search__queries">';
      queries.forEach(function (q) {
        html += '<li><a href="' + q.url + '">' + q.styled_text + '</a></li>';
      });
      html += '</ul>';
    }
    if (products.length) {
      html += '<ul class="predictive-search__products">';
      products.forEach(function (p) {
        html += '<li><a href="' + p.url + '">' +
          '<img src="' + (p.image || '') + '" width="48" height="48" alt="' + p.title.replace(/"/g, '&quot;') + '">' +
          '<span><strong>' + p.title + '</strong><em>' + p.price + '</em></span>' +
          '</a></li>';
      });
      html += '</ul>';
    }
    resultsEl.innerHTML = html;
    resultsEl.hidden = false;
  }

  input.addEventListener('input', function () {
    var q = input.value.trim();
    clearTimeout(debounceTimer);
    if (q.length < 2) {
      resultsEl.hidden = true;
      resultsEl.innerHTML = '';
      return;
    }
    debounceTimer = setTimeout(function () {
      fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product,query&resources[limit]=6&resources[options][fields]=title,product_type,vendor,sku')
        .then(function (res) { return res.json(); })
        .then(render)
        .catch(function () {});
    }, 250);
  });

  document.addEventListener('click', function (e) {
    if (!wrapper.contains(e.target)) {
      resultsEl.hidden = true;
    }
  });
})();
